import React from "react";

const About: React.FC = () => {
  return <h1>About</h1>;
};

export default About;